import type { RouteRecordRaw } from 'vue-router'

const routes: RouteRecordRaw[] = [
  {
    path: '/casos',
    name: 'casos.index',
    component: () => import('./views/CasosIndex.vue'),
    meta: {
      layout: 'auth',
      requiresAuth: true,
      requiresPermission: 'casos.read',
      breadcrumb: 'Casos',
    },
  },
  {
    path: '/casos/:id',
    name: 'casos.detalle',
    component: () => import('./views/CasoDetalle.vue'),
    props: true,
    meta: {
      layout: 'auth',
      requiresAuth: true,
      requiresPermission: 'casos.read',
      breadcrumb: 'Detalle del caso',
    },
  },
]

export default routes
